import { defineMessages } from 'react-intl';

export default defineMessages({
  allVideos: {
    id: 'widget.strip-view.all-videos',
    defaultMessage: 'All Videos',
  },
  close: {
    id: 'widget.strip-view.close',
    defaultMessage: 'Close',
  },
});



// WEBPACK FOOTER //
// ./src/widget/views/desktop/strip/translations.js